/**
 * Baydoun Footwear — light/dark theme toggle.
 *
 * The current theme is applied to <html data-bd-theme="light|dark"> by an
 * inline script in layout/theme.liquid before first paint (no flash).
 * This file wires up the toggle buttons and keeps following the operating
 * system appearance until the visitor makes a manual choice.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'baydoun-theme';

  function currentTheme() {
    return document.documentElement.getAttribute('data-bd-theme') === 'dark' ? 'dark' : 'light';
  }

  function storedTheme() {
    try {
      var value = localStorage.getItem(STORAGE_KEY);
      return value === 'dark' || value === 'light' ? value : null;
    } catch (error) {
      return null;
    }
  }

  function applyTheme(theme) {
    document.documentElement.setAttribute('data-bd-theme', theme);
    syncButtons();
  }

  function syncButtons() {
    var isDark = currentTheme() === 'dark';
    document.querySelectorAll('[data-bd-theme-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    });
  }

  function onToggleClick() {
    var next = currentTheme() === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (error) {
      /* Private mode — theme still switches for this page view. */
    }
  }

  function init() {
    document.querySelectorAll('[data-bd-theme-toggle]').forEach(function (button) {
      button.addEventListener('click', onToggleClick);
    });
    syncButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Until the visitor chooses manually, live-follow the OS appearance. */
  if (window.matchMedia) {
    var media = window.matchMedia('(prefers-color-scheme: dark)');
    var followSystem = function (event) {
      if (storedTheme() === null) {
        applyTheme(event.matches ? 'dark' : 'light');
      }
    };
    if (media.addEventListener) {
      media.addEventListener('change', followSystem);
    } else if (media.addListener) {
      media.addListener(followSystem);
    }
  }
})();
